<template>
  <v-container
    class="py-10"
    style="background-color: white;"
  >
    <!-- Language, Country row -->
    <v-row class="px-8">
      <!-- Location block -->
      <v-col
        v-if="formattedCountries && formattedCountries.length"
        cols="6"
        class="py-0 mb-5"
      >
        <div>
          <v-skeleton-loader
            v-if="loading"
            :loading="loading"
            width="200"
            type="text"
          />
          <template v-else-if="formattedCountries">
            <div class="font-weight-bold mr-2 subtitle-2 mb-5">
              <span
                class="brandFont"
                style="font-weight: 700;"
              >
                Locations
              </span>
            </div>

            <ul>
              <li
                v-for="(location, key) in formattedCountries"
                :key="`locationCol_${key}`"
                class="brandFont subtitle-2 font-weight-regular mb-2"
              >
                {{ location }}
              </li>
            </ul>
          </template>
        </div>
      </v-col>

      <!-- Language block -->
      <v-col
        v-if="coach && coach.profile.languages.length"
        cols="6"
        class="py-0"
      >
        <div>
          <v-skeleton-loader
            v-if="loading"
            :loading="loading"
            width="200"
            type="text"
          />
          <div v-else>
            <div class="font-weight-bold mr-2 subtitle-2 mb-5">
              <span class="brandFont">Languages</span>
            </div>
            <ul>
              <li
                v-for="(language, key) in coach.profile.languages"
                :key="key"
                class="brandFont subtitle-2 font-weight-regular mb-2"
              >
                {{ language.value }}
              </li>
            </ul>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Section2',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedCountries() {
      if (!this.coach.profile.locations) return '';
      const locationList = [];
      const order = {
        city: 1,
        region: 2,
        country: 3,
      };

      this.coach.profile.locations.forEach((location) => {
        let section = '';
        Object.keys(location).sort((a, b) => order[a] - order[b]).forEach((type) => {
          section += `${location[type].name}, `;
        });
        // Trim and remove last comma
        section = section
          .trim()
          .replace(/,+$/, '');
        locationList.push(section);
      });

      return locationList;
    },
  },
};
</script>

<style lang="scss" scoped>
  // Set custom A tag color
  .linkHighlight {
    color: #000000;

    &:hover {
      color: #3c3c3c;
      text-decoration: underline;
    }
  }
</style>
